//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionFlag(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M10.66 5H5.39L1.75 15H9.14L9.87 13H15.15L15.88 11H10.6L12.78 5H19.65L13.83 21H15.96L22.51 3H11.39L10.66 5ZM7.75 13H4.6L6.78 7H9.92L7.75 13Z" fill="currentColor" /></svg>;
}
export default IconActionFlag;